import React, { useState, useEffect } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Container,
  Box,
  Drawer,
  List,
  IconButton,
  ListItem,

  TextField,
  ListItemText,
  ListItemButton,
  ListItemIcon,
  useMediaQuery,
  Autocomplete,

  Divider,

} from '@mui/material';
import { useNavigate, useLocation } from "react-router-dom";
import InboxIcon from '@mui/icons-material/MoveToInbox';
import MailIcon from '@mui/icons-material/Mail';
import logout from "../assets/svg/Logout.svg"
import DashboardIconDark from "../assets/svg/DashboardIconDark.svg";
import DashboardIconLight from "../assets/svg/DashboardIconLight.svg";
import RequestIconDark from "../assets/svg/RequestIconDark.svg";
import RequestIconLight from "../assets/svg/RequestIconLight.svg";
import LedgerIconDark from "../assets/svg/LedgerIconDark.svg";
import LedgerIconLight from "../assets/svg/LedgerIconLight.svg";
import DepositoryIconDark from "../assets/svg/DepositoryIconDark.svg";
import DepositoryIconLight from "../assets/svg/DepositoryIconLight.svg";
import TradeBookIconDark from "../assets/svg/TradeBookDark.svg";
import TradeBookIconLight from "../assets/svg/TradeBookLight.svg";
import PANDLIconDark from "../assets/svg/PANDLIconDark.svg"
import PANDLIconLight from "../assets/svg/PANDLIconLight.svg"
import ActivateFnODark from "../assets/svg/ActivateFnODark.svg";
import ActivateFnOLight from "../assets/svg/ActivateFnOLight.svg";
import NotificationsIcon from '@mui/icons-material/Notifications';
import MenuIcon from '@mui/icons-material/Menu';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import Dashboard from '../containers/Dashboard';
import LedgerController from '../containers/LedgerController';
import Depository from '../containers/Depository';
import Request from '../containers/Request';
import Tradebook from '../containers/Tradebook';
import AppConfig from '../AppConfig';
import { ReactComponent as AppLogo } from '../assets/svg/logo.svg';
import { useAppData } from '../redux/appDataProvider';
import { useSelector } from 'react-redux';
import ApiClient from '../utilities/apiClient';

import PandL from '../containers/pandl';
import ActiveFnO from '../containers/FAndO/ActivateFnO';
import AddNominee from '../containers/Nominee/AddNominee'; // srini - 30-05-25
import Contract from '../containers/Contract/Contract';
import AccountClosure from '../containers/AccountClosure/AccountClosureForm';
import UserProfile from '../containers/UserProfile/UserProfile'; // srini - 24-07-25
import MyModal from "../components/session_expired"
import dayjs from 'dayjs';
import POAActivation from '../containers/ActivatePoa/ActivatePoa';
import { x64 } from 'crypto-js';

const MainLayout = ({ children, selectedItem, section }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [drawerItems, setDrawerItems] = useState(AppConfig.drawerItems);
  const [sectionToShow, setSectionToShow] = useState(section);
  const isSmallScreen = useMediaQuery('(max-width : 1400px)');
  const screen1000px = useMediaQuery('(max-width : 1000px)');
  const screen700px = useMediaQuery('(max-width : 700px)')
  const screen600px = useMediaQuery('(max-width : 600px)')
  const screen460px = useMediaQuery('(max-width : 460px)')
  const drawerWidth = isSmallScreen ? '100%' : 263;
  const { userFnYear, setUserFnYear } = useAppData([]);
  const apiToken = useSelector(state => state.auth.apiToken);
  const userId = useSelector(state => state.auth.userId);
  const { selectedYear, setSelectedYear } = useAppData({});
  const { expandedItem, setExpandedItem } = useAppData(null) // srini - 30-05-25

  const handleYearChange = (event, newValue) => {
    console.info('handleYearChange', newValue);
    setSelectedYear(newValue);
  };
  const [showmodal, setShowModal] = React.useState(false);
  // Construct default year label

  // Commented by dev-trupti to check the XTS token login - 5
  if (selectedYear.Database_Year)
    localStorage.setItem("year", selectedYear.Database_Year)
  const initializeGlobals = async () => {
    try {
      const apiClient = new ApiClient(apiToken);
      apiClient.fetchData(
        AppConfig.api.Client.getFnYear,
        "POST",
        {
          "ClientCode": userId,
        })
        .then((response) => {
          if(response===401){setShowModal(true)}
          if (response && response.Success === "True" && response.hasOwnProperty("Success Description")) {
            let responseData = response["Success Description"];
            if (Array.isArray(responseData) && responseData.length > 0) {
              setUserFnYear(responseData);
              const currentYear = new Date().getFullYear();
              //start dev-Ayush 06-01-2024 , selecting the current financial year
              const currentYearData = responseData.find(item => {
                if(dayjs().isBetween(dayjs(item.start_date).subtract(1,"day"), dayjs(item.End_date).add(1,"day"))){
                  return item
                }
              }) || responseData[responseData.length - 1]
              //end 
              currentYearData && setSelectedYear(currentYearData);
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.error('Error initializing globals:', error);
    }
  };
  // srini - 30-05-25
  const handleListItemClick = (item, isSubItem = false) => {
    console.log("handleListItemClick",item, isSubItem )
  const url = AppConfig.drawerItemsUrls[item];

  // if (!isSubItem) {
  //   if (item === "Manage Accounts") {
  //     setExpandedItem(prev => {
  //       if (prev === "Manage Accounts") {
          
  //         if (screen1000px) {
  //           return "Manage Accounts";
  //         }
  //         return null;
  //       } else {
  //         return "Manage Accounts";
  //       }
  //     });
  //   } else {
      // setExpandedItem(null);
      if (isSmallScreen) handleDrawerClose(); // srini - 27/06/25
  //   }
  // } else {
  //   if (screen1000px) handleDrawerClose();
  // }

  if (url) {
    navigate(url);
  }
};

  useEffect(() => {
    setExpandedItem("Manage Accounts")
  }, [])

  const renderContent = () => {
    switch (selectedItem) {
      case 'Dashboard':
      case 'AddFunds':
      case 'Withdraw':
      case 'FundTransferStatus':
      case 'MarginPledge':
        return <Dashboard section={sectionToShow} />;
      case 'Ledger':
        return <LedgerController />;
      case 'Depository':
        return <Depository />;
      case 'BankAccount': // srini - 30-05-25
        return <Request />;
      case 'Tradebook':
        return <Tradebook />;
      case 'PandL':
        return <PandL />;
      case 'ActivateFnO':
        return <ActiveFnO />;
      case 'AccountClosure':
        return <AccountClosure/>;
      case 'ActivatePoa':
        return <POAActivation/>;
      case 'MyProfile': // srini - 24-07-25
        return <UserProfile />
      case 'AddNominee':
        return <AddNominee />; // srini - 30-05-25
        case 'Report':
        return <Contract />; 
      default:
        return <Dashboard section={sectionToShow} />;
    }
  };
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  const handleDrawerClose = () => {
    // srini - 27/06/25
    if (isClosing || !mobileOpen) {
      console.warn("Prevented redundant close");
      return;
    }
    setIsClosing(true);
    setMobileOpen(false);
  };

  const handleDrawerTransitionEnd = () => {
    setIsClosing(false);
  };
  const handleDrawerOpen = () => {
    setDrawerOpen(true);
  };
  const handleDrawerToggle = () => {
    if (!isClosing) {
      setMobileOpen(!mobileOpen);
    }
  };
  const handleHomeButtonClick = () => {
    // setSelectedItem(<Dashboard />);
    navigate('/dashboard');
    setSectionToShow('dashboard');
  };

  const handleNotifications = () => {

  };
  const handleLogout = () => {
    window.location.href = "/"//AppConfig.basAppUrl;

    // Prevent user from going back to the previous page
    // if (window.history && window.history.replaceState) {
    //   window.history.replaceState(null, null, window.location.href);
    // }
  };

  // Commented by dev-trupti to check the XTS token login - 6
  useEffect(() => {
    initializeGlobals()
  }, [])


  useEffect(() => {
    // Parse the pathname from the location object
    const pathname = location.pathname;
    // Split the pathname by '/' and get the last segment
    const segments = pathname.split('/');
    const lastSegment = segments[segments.length - 1];
    // Set sectionToShow based on the last segment
    switch (lastSegment) {
      case 'addfunds':
        setSectionToShow('addfunds');
        break;
      case 'withdraw':
        setSectionToShow('withdraw');
        break;
      case 'marginpledge':
        setSectionToShow('marginpledge');
        break;
      case 'fundtransferstatus':
        setSectionToShow('fundtransferstatus');
        break;
      default:
        setSectionToShow('dashboard');
        break;
    }
    // if (lastSegment === 'addfunds') {
    //   setSectionToShow('addfunds');
    // } else {
    //   setSectionToShow('dashboard');
    // }

  }, [location.pathname]);

  return (
    <Box sx={{ display: 'flex' }}>
      <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
        <Toolbar>
          {/* Changed to onTouch event - 23-07-24 - Dev Srini */}
          {
            isSmallScreen && <IconButton
              size="large"
              edge="start"
              color="inherit"
              aria-label="menu"
              sx={{ mr: screen600px ? 0 : 2 }}
              onClick={() => {
                if (!screen1000px) {
                  handleDrawerToggle()
                }
              }}
              onTouchStart={() => {
                if (screen1000px) {
                  handleDrawerToggle()
                }
              }}
            >
              <MenuIcon />
            </IconButton>
          }
         
          <Typography variant="h6" sx={{ flexGrow: 1 }}>
            {/* Changed to onTouch event - 23-07-24 - Dev Srini */}
            <AppLogo style={{ cursor: "pointer", marginTop: "10px", height: screen600px ? "18px" : "24px", marginLeft: screen600px ? "-20px" : "0px" }} onClick={handleHomeButtonClick} onTouchStart={handleHomeButtonClick}/>
            {/* version added - 02-08-2024 -Dev Srini */}
            <Typography component="span" display="none">1.0.4</Typography>
          </Typography>
          {screen600px ? (
            <Autocomplete
              disableClearable
              disablePortal
              options={userFnYear}
              sx={{
                mr: !screen460px && 4,
                width: 150, height: 30, mb: "5px", borderRadius: "8px", "& .MuiAutocomplete-inputRoot": {
                  color: '#F3D45E',
                  paddingTop : "3px !important",
                  paddingBottom : "3px !important"
                },
              }}
              value={selectedYear}
              onChange={handleYearChange}
              size='small'
              renderInput={(params) => <TextField {...params} />}
              getOptionLabel={(option) => `${option.Database_Year}-${parseInt(option.Database_Year) + 1}`}
            />
          ) : (<Autocomplete
            disableClearable
            disablePortal
            options={userFnYear}
            sx={{ mr: 4, width: screen700px ? 200 : 300, height: 40 }}
            value={selectedYear}
            onChange={handleYearChange}
            size='small'
            renderInput={(params) => <TextField {...params} label="Year" />}
            getOptionLabel={(option) => `Year ${option.Database_Year}-${parseInt(option.Database_Year) + 1}`}
          />)}
          {!screen460px && <>
            <IconButton
              size="large"
              edge="start"
              color="inherit"
              aria-label="menu"
              onClick={handleNotifications}
              sx={{ mr: 2 }}
            >
              <NotificationsIcon />
            </IconButton>
            {/* Changed to onTouch event - 23-07-24 - Dev Srini */}
            <IconButton
              size="large"
              edge="start"
              color="inherit"
              aria-label="menu"
              onTouchStart={handleLogout}
            >
              <img src={logout} />
            </IconButton>
          </>}
        </Toolbar>
      </AppBar>
      <Drawer
        variant={isSmallScreen ? "temporary" : "permanent"}
        open={mobileOpen}
        onTransitionEnd={handleDrawerTransitionEnd}
        onClose={handleDrawerClose}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          "& .MuiDrawer-root": {
            backgroundColor: "red !important"
          },
          [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: 'border-box', background: "#241E41" },
        }}
      >
        <Toolbar />
        <Box sx={{ overflow: 'auto' }}>
          <List sx={{ padding: "0px" }} > 
            {/*  srini - 30-05-25 */}
            {drawerItems.map((item, index) => {
              const isParent = typeof item === "object";
  const text = isParent ? item.label : item

              return (
              <React.Fragment key={text}>
              <ListItem
                key={text}
                disablePadding
                sx={{
                  backgroundColor: selectedItem === text ? '#F3D45E' : '#1E0F36',
                  color: selectedItem === text ? '#1E0F36' : 'inherit',
                  borderBottom: "2px solid #131E2E"
                }}>
                  {/* Changed to onTouch event - 23-07-24 - Dev Srini */}
                <ListItemButton
                  onClick={() => handleListItemClick(text)}
                  onTouchStart={() => handleListItemClick(text)}
                  >
                  <ListItemIcon
                    sx={{
                      backgroundColor: selectedItem === text ? '#F3D45E' : 'inherit',
                      color: selectedItem === text ? '#1E0F36' : 'inherit'
                    }}>
                    {index === 0 && <img style={{ marginLeft: "5px" }} src={selectedItem === text ? DashboardIconDark : DashboardIconLight} />}
                    {index === 1 && <img style={{ marginLeft: "8px" }} src={selectedItem === text ? LedgerIconDark : LedgerIconLight} />}
                    {index === 2 && <img style={{ marginLeft: "8px" }} src={selectedItem === text ? DepositoryIconDark : DepositoryIconLight} />}
                    {index === 3 && <img style={{ marginLeft: "8px" }} src={selectedItem === text ? TradeBookIconDark : TradeBookIconLight} />}
                    {index === 4 && <img style={{ marginLeft: "5px" }} src={selectedItem === text ? PANDLIconDark : PANDLIconLight} />}
                    {index === 5 && <img style={{ marginLeft: "10px" }} src={selectedItem === text ? RequestIconDark : RequestIconLight} />}
                    {index === 6 && <img style={{ marginLeft: "10px" }} src={selectedItem === text ? ActivateFnODark : ActivateFnOLight} />}
                    {index === 7 && <img style={{ marginLeft: "10px" }} src={selectedItem === text ? PANDLIconDark : PANDLIconLight} />}

                  </ListItemIcon>
                  <ListItemText
                    primary={text === "PandL" ? "Profit and Loss" : text === "ActivateFnO" ? "Activate FnO" : text === "MyProfile" ? "My Profile" : text === "Report" ? "Report" : text}
                    primaryTypographyProps={{ fontFamily: selectedItem === text ? "Cardium Bold" : "Cardium Light" }}
                  />

                </ListItemButton>

              </ListItem>

              {/* Render sub-items - srini - 30-05-25 */}
      {isParent && expandedItem === text && item.children.map((subItem) => (
        <Box key={subItem} >
          <ListItem
            disablePadding
            sx={{
              backgroundColor: selectedItem === subItem ? '#F3D45E' : '#1E0F36',
              color: selectedItem === subItem ? '#1E0F36' : 'inherit',
              borderBottom: "2px solid #131E2E",

            }}
          >
            <ListItemButton onClick={() => handleListItemClick(subItem, true)}>
              <ListItemText
                primary={
                  subItem === "AddNominee"
                    ? "Add Nominee"
                    : subItem === "BankAccount"
                      ? "Bank Account"
                      : subItem === "ActivateFnO"
                        ? "Activate F&O"
                        : subItem === "AccountClosure"
                          ? "Account Closure"
                        : subItem === "MyProfile"
                          ? "My Profile"
                          : subItem === "ActivatePoa" ? subItem === "ContractNote"
                          ? "Contract Note"
                          : "Activate DDPI" : subItem
                }
                primaryTypographyProps={{
                  fontFamily: selectedItem === subItem ? "Cardium Bold" : "Cardium Light",
                  color: selectedItem === subItem ? "#0B1420" : "#ffffff",
                  marginLeft: "90px !important"
                }}
              />
            </ListItemButton>
          </ListItem>
        </Box>
  ))}
              </React.Fragment>
            )
})}
            {/* End - srini - 30-05-25 */}
            {screen460px && <>
              <ListItem>
                <ListItemButton sx={{ padding: "0px 0px 0px 5px" }}>
                  <ListItemIcon>
                    <NotificationsIcon sx={{ height: "23px" }} />
                  </ListItemIcon>
                  <ListItemText primary={"Notification"} primaryTypographyProps={{ fontFamily: "Cardium Light" }} sx={{ marginLeft: "-10px" }} />
                </ListItemButton>
              </ListItem>
              <ListItem sx={{borderTop : "1px solid rgba(255, 255, 255, 0.12);"}}>
                {/* Changed to onTouch event - 23-07-24 - Dev Srini */}
                <ListItemButton onTouchStart={handleLogout} sx={{ padding: "0px 0px 0px 10px" }}>
                  <ListItemIcon>
                    <img height={15} src={logout} />
                  </ListItemIcon>
                  <ListItemText primary={"Logout"} primaryTypographyProps={{ fontFamily: "Cardium Light" }} sx={{ marginLeft: "-10px" }} />
                </ListItemButton>
              </ListItem>
            </>}
          </List>

          <Divider />
        </Box>
      </Drawer>

      <Box component="main" sx={{ flexGrow: 1, p: 0, m: 0, width: "100%" }}>

        <Toolbar />
        <Container sx={{ padding: 0, marginLeft: 0, width: "100%", "&.MuiContainer-maxWidthLg": { maxWidth: "100%" } }}>
          {renderContent()}
        </Container>

      </Box>
      <MyModal canShow={showmodal} />
    </Box>
  );
};
export default MainLayout;
